// export const DISABLED_ALPHA = 0.4;

export const COLOR_TEXT = 0xffffff;
export const COLOR_HIGHLIGHT = 0xffae00;
export const COLOR_HIGHLIGHT_GREEN = 0x0DB11;
export const AUTOPLAY_COUNTER_HIGHLIGHT = 0xffd667;
export const COLOR_JURISDICTION_BG = 0x000000;
// export const COLOR_POPUP_BG = 0x000000;
// export const COLOR_POPUP_BG2 = 0x252525;
// export const COLOR_POPUP_BG3 = 0x3B3B3B;
// export const COLOR_ACCENT = 0x00B241;
// export const COLOR_ERROR = 0xff0000;

// export const TOGGLE_COLOR_TRUE = COLOR_ACCENT;
// export const TOGGLE_COLOR_FALSE = COLOR_POPUP_BG3;

